// Tiny fixed-position overlay that shows preload progress: # of assets,
// MB downloaded, and which tiers have completed. Mounted from main.ts when
// the URL contains ?debugPreload=1.

import { preloader, type PreloadProgress } from '../assets/Preloader';

export function mountPreloadDebugPanel(): () => void {
  const root = document.createElement('div');
  root.id = 'preload-debug-panel';
  root.style.cssText = [
    'position:fixed',
    'top:8px',
    'right:8px',
    'z-index:99999',
    'background:rgba(0,0,0,0.75)',
    'color:#0f0',
    'font:12px/1.4 ui-monospace,Menlo,Consolas,monospace',
    'padding:8px 10px',
    'border:1px solid #0f0',
    'border-radius:4px',
    'pointer-events:none',
    'white-space:pre',
    'min-width:180px',
  ].join(';');
  document.body.appendChild(root);

  const render = (p: PreloadProgress): void => {
    const mb = (p.bytesDownloaded / (1024 * 1024)).toFixed(2);
    const tiers = [1, 2, 3, 4, 5]
      .map((t) => (p.completedTiers.has(t as 1 | 2 | 3 | 4 | 5) ? `${t}` : `·`))
      .join(' ');
    root.textContent =
      `preload\n` +
      `assets   ${p.completedAssets} / ${p.totalAssets}\n` +
      `download ${mb} MB\n` +
      `tiers    ${tiers}`;
  };

  const unsubscribe = preloader.subscribe(render);
  return () => {
    unsubscribe();
    root.remove();
  };
}
